















































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data/load_options';
import { formatNumber } from 'devextreme/localization';
import dxDataGrid from 'devextreme/ui/data_grid';
import notify from 'devextreme/ui/notify';
import { DxButton } from 'devextreme-vue/button';
import {
  DxColumn,
  DxDataGrid,
  DxLookup,
  DxSummary,
  DxTotalItem
} from 'devextreme-vue/data-grid';
import { DxSelectBox } from 'devextreme-vue/select-box';
import ApplyExchangeRate from '@/components/invoice-lookup/apply-exchange-rate.vue';
import EditInvoiceDate from '@/components/invoice-lookup/edit-invoice-date.vue';
import EditInvoiceNumber from '@/components/invoice-lookup/edit-invoice-number.vue';
import EditLineItemTotal from '@/components/invoice-lookup/edit-line-item-total.vue';
import { CountryDto } from '@/models/CountryDto';
import { SelectOption } from '@/models/SelectOption';
import { AgentDto } from '@/models/agent/AgentDto';
import { BatchDto } from '@/models/batch/BatchDto';
import { InvoiceDto } from '@/models/invoice/InvoiceDto';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';
import { ClientService } from '@/service/ClientService';
import { InvoiceLineItemService } from '@/service/InvoiceLineItemService';
import { InvoiceLineItemApplyExchangeRateDto } from '@/models/invoice/InvoiceLineItemApplyExchangeRateDto';
import { InvoiceLineItemBulkApplyExchangeRateDto } from '@/models/invoice/InvoiceLineItemBulkApplyExchangeRateDto';
import { InvoiceLineItemBulkOperationResponseDto } from '@/models/invoice/InvoiceLineItemBulkOperationResponseDto';
import { InvoiceLineItemBulkUpdateInvoiceDateDto } from '@/models/invoice/InvoiceLineItemBulkUpdateInvoiceDateDto';
import { InvoiceLineItemBulkUpdateInvoiceNumberDto } from '@/models/invoice/InvoiceLineItemBulkUpdateInvoiceNumberDto';
import { InvoiceLineItemUpdateInvoiceDateDto } from '@/models/invoice/InvoiceLineItemUpdateInvoiceDateDto';
import { InvoiceLineItemUpdateInvoiceNumberDto } from '@/models/invoice/InvoiceLineItemUpdateInvoiceNumberDto';
import { InvoiceLineItemUpdateTotalDto } from '@/models/invoice/InvoiceLineItemUpdateTotalDto';
import String from '@/utilities/String';

@Component({
  components: {
    ApplyExchangeRate,
    DxButton,
    DxColumn,
    DxDataGrid,
    DxLookup,
    DxSelectBox,
    DxSummary,
    DxTotalItem,
    EditInvoiceDate,
    EditInvoiceNumber,
    EditLineItemTotal
  }
})
export default class InvoiceLookupGrid extends Vue {
  private readonly applyExchangeRateRef: string = 'applyExchangeRateRef';
  private readonly clientService: ClientService = new ClientService();
  private readonly editInvoiceDateRef: string = 'editInvoiceDateRef';
  private readonly editInvoiceNumberRef: string = 'editInvoiceNumberRef';
  private readonly editLineItemTotalRef: string = 'editLineItemTotalRef';
  private readonly invoiceLineItemService: InvoiceLineItemService = new InvoiceLineItemService();

  private changingClient: boolean = false;
  private clients: SelectOption[] = [];
  private dataGrid: dxDataGrid | undefined;
  private selectedAgent: Guid | null = null;
  private selectedBatch: Guid | null = null;
  private selectedClient: Guid | null = null;
  private selectedCountry: number | null = null;
  private selectedInvoiceNumber: string | null = null;

  private get dataSource(): DataSourceOptions {
    return {
      store: this.dataStore,
      reshapeOnPush: true
    };
  }

  private get dataStore() {
    return new CustomStore({
      key: 'InvoiceLineItemId',
      load: options => this.loadDataGrid(options)
    });
  }

  private get modifyButtonsDisabled() {
    return this.selectedClient == null || this.selectedAgent == null || this.selectedInvoiceNumber == null;
  }

  private get applyExchangeRateDialog() {
    return this.$refs[this.applyExchangeRateRef] as ApplyExchangeRate;
  }

  private get editInvoiceDateDialog() {
    return this.$refs[this.editInvoiceDateRef] as EditInvoiceDate;
  }

  private get editInvoiceNumberDialog() {
    return this.$refs[this.editInvoiceNumberRef] as EditInvoiceNumber;
  }

  private get editLineItemTotalDialog() {
    return this.$refs[this.editLineItemTotalRef] as EditLineItemTotal;
  }

  private async loadDataGrid(options: LoadOptions) {
    if (this.selectedClient != null) {
      return await this.clientService.getClientLineItems(this.selectedClient, options);
    }

    return Promise.resolve<any>([]);
  }

  @Watch('selectedBatch')
  private onSelectedBatchChanged() {
    if (!this.changingClient) {
      this.updateLookupData();
    }
  }

  @Watch('selectedAgent')
  private onSelectedAgentChanged() {
    if (!this.changingClient) {
      this.updateLookupData();
    }
  }

  private onSelectedClientChanged() {
    this.changingClient = true;
    this.clearFilters();
    this.setPageIndex(0);
    this.updateLookupData();

    this.$nextTick(() => {
      this.changingClient = false;
    });
  }

  @Watch('selectedInvoiceNumber')
  private onSelectedInvoiceNumberChanged() {
    if (!this.changingClient) {
      this.updateLookupData();
    }
  }

  @Watch('selectedCountry')
  private onSelectedCountryChanged() {
    if (!this.changingClient) {
      this.updateLookupData();
    }
  }

  private clearFilters() {
    if (this.dataGrid != null) {
      this.dataGrid.clearFilter();
    }
  }

  private setPageIndex(newIndex: number) {
    if (this.dataGrid != null) {
      this.dataGrid.pageIndex(newIndex);
    }
  }

  async created() {
    await this.loadData();
  }

  private async loadData() {
    this.clients = await this.clientService.getAllSelectOptions();
  }

  private async updateLookupData() {
    if (this.selectedClient == null) {
      return;
    }

    await this.clientService.getLookupData(this.selectedClient, this.selectedBatch, this.selectedAgent, this.selectedInvoiceNumber, this.selectedCountry)
      .then(result => {
        let batchesDataSource = this.getBatchesDataSource(result.Batches);
        let agentsDataSource = this.getAgentsDataSource(result.Agents);
        let invoiceNumbersDataSource = this.getInvoiceNumbersDataSource(result.Invoices);
        let countriesDataSource = this.getCountriesDataSource(result.Countries);

        this.setDataGridLookupColumnData('BatchId', batchesDataSource);
        this.setDataGridLookupColumnData('AgentId', agentsDataSource);
        this.setDataGridLookupColumnData('InvoiceNumber', invoiceNumbersDataSource);
        this.setDataGridLookupColumnData('CountryId', countriesDataSource);
      });
  }

  private getBatchesDataSource(batches: BatchDto[]): DataSourceOptions {
    return {
      store: batches,
      paginate: true,
      pageSize: 100,
      sort: [{ selector: 'BatchName', desc: true }]
    };
  }

  private getAgentsDataSource(agents: AgentDto[]): DataSourceOptions {
    return {
      store: agents,
      paginate: true,
      pageSize: 100,
      sort: 'AgentName'
    };
  }

  private getInvoiceNumbersDataSource(invoiceNumbers: InvoiceDto[]): DataSourceOptions {
    return {
      store: invoiceNumbers,
      paginate: true,
      pageSize: 100,
      sort: 'InvoiceNumber'
    };
  }

  private getCountriesDataSource(countries: CountryDto[]): DataSourceOptions {
    return {
      store: countries,
      paginate: true,
      pageSize: 100,
      sort: 'CountryCode'
    };
  }

  private setDataGridLookupColumnData(columnId: string, lookupData: any) {
    this.setDataGridColumnOption(columnId, 'lookup.dataSource', lookupData);
  }

  private setDataGridColumnOption(id: string, optionName: string, optionValue: any) {
    if (this.dataGrid != null) {
      this.dataGrid.columnOption(id, optionName, optionValue);
    }
  }

  private editInvoiceDate(lineItem?: InvoiceLookupLineItemDto) {
    let invoiceDate: Date | null = null;

    if (lineItem != null && lineItem.InvoiceDate != null) {
      invoiceDate = lineItem.InvoiceDate;
      this.editInvoiceDateDialog.lineItem = lineItem;
    } else {
      invoiceDate = this.getFirstRowInvoiceDate();
      this.editInvoiceDateDialog.lineItem = null;
    }

    this.editInvoiceDateDialog.value = invoiceDate;
    this.editInvoiceDateDialog.show();
  }

  private getFirstRowInvoiceDate() {
    let data = this.getFirstRowData();
    return data != null ? data.InvoiceDate : null;
  }

  private onEditInvoiceDateDialogHiding() {
    if (this.editInvoiceDateDialog.dialogResult !== true || !this.editInvoiceDateDialog.valueChanged || this.editInvoiceDateDialog.value == null) {
      return;
    }

    if (this.editInvoiceDateDialog.lineItem != null) {
      this.updateInvoiceDate(this.editInvoiceDateDialog.lineItem.InvoiceLineItemId, this.editInvoiceDateDialog.value);
    } else if (this.selectedClient != null && this.selectedAgent != null && this.selectedInvoiceNumber != null) {
      this.bulkUpdateInvoiceDate(this.selectedClient, this.selectedAgent, this.selectedInvoiceNumber, this.editInvoiceDateDialog.value);
    }
  }

  private async updateInvoiceDate(lineItemId: Guid, invoiceDate: Date) {
    let dto: InvoiceLineItemUpdateInvoiceDateDto = {
      InvoiceDate: invoiceDate
    };

    notify('Updating invoice date...');

    await this.invoiceLineItemService.updateInvoiceDate(lineItemId, dto)
      .then(result => {
        this.pushUpdateToDataStore(result);
        notify('Invoice date successfully updated.', 'success');
      });
  }

  private async bulkUpdateInvoiceDate(clientId: Guid, agentId: Guid, invoiceNumber: string, invoiceDate: Date) {
    let dto: InvoiceLineItemBulkUpdateInvoiceDateDto = {
      ClientId: clientId,
      AgentId: agentId,
      InvoiceNumber: invoiceNumber,
      InvoiceDate: invoiceDate
    };

    notify('Updating invoice date...');

    await this.invoiceLineItemService.bulkUpdateInvoiceDate(dto)
      .then(result => {
        this.refreshDataGrid();
        notify(this.getBulkOperationSuccessMessage(result), 'success');
      });
  }

  private editInvoiceNumber(lineItem?: InvoiceLookupLineItemDto) {
    let invoiceNumber: string = String.empty;

    if (lineItem != null && lineItem.InvoiceNumber != null) {
      invoiceNumber = lineItem.InvoiceNumber;
      this.editInvoiceNumberDialog.lineItem = lineItem;
    } else {
      invoiceNumber = this.getFirstRowInvoiceNumber();
      this.editInvoiceNumberDialog.lineItem = null;
    }

    this.editInvoiceNumberDialog.value = invoiceNumber;
    this.editInvoiceNumberDialog.show();
  }

  private getFirstRowInvoiceNumber() {
    let data = this.getFirstRowData();
    return data != null ? data.InvoiceNumber : String.empty;
  }

  private onEditInvoiceNumberDialogHiding() {
    if (this.editInvoiceNumberDialog.dialogResult !== true || !this.editInvoiceNumberDialog.valueChanged) {
      return;
    }

    if (this.editInvoiceNumberDialog.lineItem != null) {
      this.updateInvoiceNumber(this.editInvoiceNumberDialog.lineItem.InvoiceLineItemId, this.editInvoiceNumberDialog.value);
    } else if (this.selectedClient != null && this.selectedAgent != null && this.selectedInvoiceNumber != null) {
      this.bulkUpdateInvoiceNumber(this.selectedClient, this.selectedAgent, this.selectedInvoiceNumber, this.editInvoiceNumberDialog.value);
    }
  }

  private async updateInvoiceNumber(lineItemId: Guid, invoiceNumber: string) {
    let dto: InvoiceLineItemUpdateInvoiceNumberDto = {
      InvoiceNumber: invoiceNumber
    };

    notify('Updating invoice number...');

    await this.invoiceLineItemService.updateInvoiceNumber(lineItemId, dto)
      .then(result => {
        this.pushUpdateToDataStore(result);
        notify('Invoice number successfully updated.', 'success');
        this.updateInvoiceLookupData();
      });
  }

  private async updateInvoiceLookupData() {
    if (this.selectedClient == null) {
      return;
    }

    await this.clientService.getInvoiceLookupData(this.selectedClient, this.selectedBatch, this.selectedAgent, this.selectedCountry)
      .then(result => {
        let invoiceNumbersDataSource = this.getInvoiceNumbersDataSource(result.Invoices);
        this.setDataGridLookupColumnData('InvoiceNumber', invoiceNumbersDataSource);
      });
  }

  private async bulkUpdateInvoiceNumber(clientId: string, agentId: string, invoiceNumber: string, newInvoiceNumber: string) {
    let dto: InvoiceLineItemBulkUpdateInvoiceNumberDto = {
      ClientId: clientId,
      AgentId: agentId,
      InvoiceNumber: invoiceNumber,
      NewInvoiceNumber: newInvoiceNumber
    };

    notify('Updating invoice number...');

    await this.invoiceLineItemService.bulkUpdateInvoiceNumber(dto)
      .then(result => {
        this.refreshDataGrid();
        notify(this.getBulkOperationSuccessMessage(result), 'success');
        this.updateInvoiceLookupData();
      });
  }

  private editLineItemTotal(lineItem?: InvoiceLookupLineItemDto) {
    let lineItemTotal: number = 0;

    if (lineItem != null) {
      lineItemTotal = lineItem.LineItemTotal;
      this.editLineItemTotalDialog.lineItem = lineItem;
    } else {
      lineItemTotal = this.getFirstRowLineItemTotal();
      this.editLineItemTotalDialog.lineItem = null;
    }

    this.editLineItemTotalDialog.value = lineItemTotal;
    this.editLineItemTotalDialog.show();
  }

  private getFirstRowLineItemTotal() {
    let data = this.getFirstRowData();
    return data != null ? data.LineItemTotal : 0;
  }

  private async onEditLineItemTotalDialogHiding() {
    if (this.editLineItemTotalDialog.dialogResult !== true || !this.editLineItemTotalDialog.valueChanged) {
      return;
    }

    if (this.editLineItemTotalDialog.lineItem != null) {
      let id = this.editLineItemTotalDialog.lineItem.InvoiceLineItemId;
      let dto: InvoiceLineItemUpdateTotalDto = {
        LineItemTotal: this.editLineItemTotalDialog.value
      };

      notify('Updating line item amount...');

      await this.invoiceLineItemService.updateLineItemTotal(id, dto)
        .then(result => {
          this.pushUpdateToDataStore(result);
          notify('Line item amount successfully updated.', 'success');
        });
    }
  }

  private onApplyExchangeRateClicked(lineItem?: InvoiceLookupLineItemDto) {
    let invoiceDate: Date | null = null;

    if (lineItem != null && lineItem.LineItemDate != null) {
      invoiceDate = lineItem.InvoiceDate;
      this.applyExchangeRateDialog.lineItem = lineItem;
    } else {
      invoiceDate = this.getFirstRowInvoiceDate();
      this.applyExchangeRateDialog.lineItem = null;
    }

    this.applyExchangeRateDialog.invoiceDate = invoiceDate;
    this.applyExchangeRateDialog.show();
  }

  private onApplyExchangeRateDialogHiding() {
    if (this.applyExchangeRateDialog.dialogResult !== true || this.applyExchangeRateDialog.value == null) {
      return;
    }

    if (this.applyExchangeRateDialog.lineItem != null) {
      this.applyExchangeRate(this.applyExchangeRateDialog.lineItem.InvoiceLineItemId, this.applyExchangeRateDialog.value);
    } else if (this.selectedClient != null && this.selectedAgent != null && this.selectedInvoiceNumber != null) {
      this.bulkApplyExchangeRate(this.selectedClient, this.selectedAgent, this.selectedInvoiceNumber, this.applyExchangeRateDialog.value);
    }
  }

  private async applyExchangeRate(lineItemId: Guid, exchangeRate: number) {
    let dto: InvoiceLineItemApplyExchangeRateDto = {
      ExchangeRate: exchangeRate
    };

    notify('Applying exchange rate...');

    await this.invoiceLineItemService.applyExchangeRate(lineItemId, dto)
      .then(result => {
        this.pushUpdateToDataStore(result);
        notify('Exchange rate successfully applied.', 'success');
      });
  }

  private async bulkApplyExchangeRate(clientId: Guid, agentId: Guid, invoiceNumber: string, exchangeRate: number) {
    let dto: InvoiceLineItemBulkApplyExchangeRateDto = {
      ClientId: clientId,
      AgentId: agentId,
      InvoiceNumber: invoiceNumber,
      ExchangeRate: exchangeRate
    };

    notify('Applying exchange rate...');

    await this.invoiceLineItemService.bulkApplyExchangeRate(dto)
      .then(result => {
        this.refreshDataGrid();
        notify(this.getBulkOperationSuccessMessage(result), 'success');
      });
  }

  private refreshDataGrid(changesOnly: boolean = true) {
    if (this.dataGrid != null) {
      this.dataGrid.refresh(changesOnly);
    }
  }

  private pushUpdateToDataStore(lineItem: InvoiceLookupLineItemDto) {
    this.dataStore.push([
      {
        type: 'update',
        data: lineItem,
        key: lineItem.InvoiceLineItemId
      }
    ]);
  }

  private getFirstRowData() {
    if (this.dataGrid == null) {
      return null;
    }

    let rows = this.dataGrid.getVisibleRows();
    if (rows.length > 0 && rows[0].data != null) {
      return rows[0].data as InvoiceLookupLineItemDto;
    }

    return null;
  }

  private getBulkOperationSuccessMessage(result: InvoiceLineItemBulkOperationResponseDto) {
    let optionalPlural = result.InvoiceLineItemsUpdated === 1 ? String.empty : 's';
    let lineItemsUpdated = formatNumber(result.InvoiceLineItemsUpdated, 'fixedPoint');
    return `Successfully updated ${lineItemsUpdated} line item${optionalPlural}.`;
  }

  private onDataGridInitialized(e: any) {
    this.dataGrid = e.component;
  }

  private onDataErrorOccurred(e: any) {
    e.error.message = 'Failed to load data. Please refresh the page.';
  }

  private getGridHeight() {
    return window.innerHeight - 250;
  }
}
